import { GooglePlacesService } from '@/services/google-places';
import useSWR from 'swr';

export const useReviews = () => {
    return useSWR('reviews', GooglePlacesService.getReviews);
};
